// [KAYIT-HATA] (Baris, 17 Eki 2026) Kisi adi kurali — backend/services/ad_kurali.py ile AYNI kural.
// Normallestirme: NFC; gorunmez bicim karakterleri (\p{Cf}: sifir genislik, BOM, yumusak tire) silinir; her tur bosluk (NBSP dahil)
// tek bosluga iner; bas/son kirpilir. Kabul: Unicode harf (\p{L}) + birlesik isaret (\p{M}) + bosluk - ' ’ . ; en az bir harf;
// 1-50 karakter. RED: rakam, emoji, simge. RegExp yapicisi: tsconfig target es5'te `u` bayrakli kalip yazimi derleyiciye takilmasin.

export const AD_EN_UZUN = 50;
export const AD_MESAJ = "Name can only contain letters, spaces, hyphens, apostrophes and periods";

const GORUNMEZ = new RegExp("\\p{Cf}", "gu");
const BOSLUK = new RegExp("\\s+", "gu");
const HARF = new RegExp("\\p{L}", "u");
const IZINLI = new RegExp("^[\\p{L}\\p{M} \\-'\u2019.]+$", "u");

export function adNormallestir(v: string): string {
  return (v || "").normalize("NFC").replace(GORUNMEZ, "").replace(BOSLUK, " ").trim();
}

/** Kurala uymuyorsa kullaniciya gosterilecek metin, uyuyorsa null. */
export function adHatasi(v: string): string | null {
  const n = adNormallestir(v);
  if (!n) return "Please enter your name";
  if (n.length > AD_EN_UZUN) return `Name must be at most ${AD_EN_UZUN} characters`;
  if (!IZINLI.test(n) || !HARF.test(n)) return AD_MESAJ;
  return null;
}
